import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CNReport } from 'src/app/models/cnreport';

@Component({
  selector: 'app-report-dialog',
  templateUrl: './report-dialog.component.html',
  styleUrls: ['./report-dialog.component.scss']
})
export class ReportDialogComponent implements OnInit {

  public report: CNReport;

  constructor(private dialog: MatDialog, private dialogRef: MatDialogRef<ReportDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    if (data && data.report) {
      this.report = data.report;
    }
  }

  ngOnInit(): void {
  }

  close() {
    this.dialogRef.close();
  }
}
